import {pressActions} from '../actions';
import * as Date from '../elements/dates/dateHelpers';

export default function press(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case pressActions.SET_PRESS: return setPressReducer(newState, action);
        case pressActions.GENERAL_PRESS_REQUEST: return setPressReducer(newState, action);
        case pressActions.GENERAL_PRESS_SUCCESS: return createAndEditReducer(newState, action);
        case pressActions.DELETE_PRESS_SUCCESS: return deletePressReducer(newState, action);
        case pressActions.GENERAL_PRESS_ERROR: return setPressReducer(newState, action);
        default:
            return newState;
    }
}

function setPressReducer(newState, action) {
    delete action.type;

        newState = Object.assign(newState, {...action});
    return newState;
}

function createAndEditReducer(newState, action) {
    delete action.type;
    delete action.body.type;

    const itemIndex = newState.body.find( item => item.id === action.body.id );

    if ( !itemIndex ) {
        newState.body.push( action.body )
    } else {
        newState.body[ newState.body.indexOf( itemIndex ) ] = action.body;
    }

    let arrCopy = [...newState.body], orderedArr = Date.orderByDate( arrCopy );

    newState.body = [...orderedArr];

    return newState;
}


function deletePressReducer(newState, action) {
    delete action.type;
    newState.body = newState.body.filter(e => e.id !== action.body);
    return newState;
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/press.js